import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { Project } from '../../data/mockProjects';

interface ProjectListProps {
  projects: Project[];
}

export const ProjectList: React.FC<ProjectListProps> = ({ projects }) => {
  const navigate = useNavigate();
  
  const getStatusVariant = (status: Project['status']) => {
    const variants: Record<Project['status'], 'success' | 'warning' | 'danger' | 'info' | 'default'> = {
      'Declaración': 'info',
      'Evaluación': 'warning',
      'Protección': 'default',
      'Negociación': 'warning',
      'Licenciado': 'success',
    };
    return variants[status];
  };
  
  return (
    <Card padding={false}>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left py-4 px-6 text-sm font-semibold text-gray-700">
                Título
              </th>
              <th className="text-left py-4 px-6 text-sm font-semibold text-gray-700">
                Estado
              </th>
              <th className="text-left py-4 px-6 text-sm font-semibold text-gray-700">
                Inventor Principal
              </th>
              <th className="text-left py-4 px-6 text-sm font-semibold text-gray-700">
                Tecnologías
              </th>
              <th className="text-left py-4 px-6 text-sm font-semibold text-gray-700">
                Fecha de Creación
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {projects.map((project) => (
              <tr
                key={project.id}
                className="hover:bg-gray-50 cursor-pointer transition-colors"
                onClick={() => navigate(`/proyectos/${project.id}`)}
              >
                <td className="py-4 px-6">
                  <p className="text-sm font-medium text-blue-600 hover:text-blue-800">
                    {project.title}
                  </p>
                </td>
                <td className="py-4 px-6">
                  <Badge variant={getStatusVariant(project.status)}>
                    {project.status}
                  </Badge>
                </td>
                <td className="py-4 px-6">
                  <p className="text-sm text-gray-900">{project.leadInventor}</p>
                </td>
                <td className="py-4 px-6">
                  <div className="flex flex-wrap gap-1">
                    {project.technologies.slice(0, 2).map((tech, idx) => (
                      <span
                        key={idx}
                        className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700"
                      >
                        {tech}
                      </span>
                    ))}
                    {project.technologies.length > 2 && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
                        +{project.technologies.length - 2}
                      </span>
                    )}
                  </div>
                </td>
                <td className="py-4 px-6">
                  <p className="text-sm text-gray-600">
                    {format(new Date(project.createdDate), 'dd MMM yyyy', { locale: es })}
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
